import { isExpEditor } from '../lib/lib'
import 'jquery-ui'

class copyToClipboard {
  constructor(element) {
    if (!element) {
      return false
    }

    if (isExpEditor()) {
      return false
    }

    this.textToCopy = element.querySelector('.text-to-copy')

    element.addEventListener('click', () => {
      navigator.clipboard.writeText(this.textToCopy.dataset.text)
    })
  }
}
export default copyToClipboard
